/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_DashboardInputs */



/**
* | output |
* | --- |
* | "AD Import Dashboard" |
*
* @param {Ad_Import_DashboardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_dashboard = /** @type {((inputs?: Ad_Import_DashboardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_DashboardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Tableau de bord d'importation AD")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Import-Dashboard")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dashboard di importazione AD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Панель управления импортом AD")
	if (locale === "es") return /** @type {LocalizedString} */ ("Panel de importación de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("广告导入仪表板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("広告インポートダッシュボード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD आयात डैशबोर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Painel de Importação de Anúncios")
	return /** @type {LocalizedString} */ ("AD Import Dashboard")
});